module.exports = __webpack_public_path__ + "static/media/CloseIcon.e7fb8985.svg";